import gql from 'graphql-tag';

export const GET_CREDIT_SUBMISSION_REVENUE = gql`
  query CreditSubmissionRevenue($creditSubmissionId: ID) {
    creditSubmissionRevenue: creditSubmission(creditSubmissionId: $creditSubmissionId) {
      lenderName
      approvedAmount
      fundedTimestamp
      lenderProfileId
      fundedTimestamp
      commissionReceivedDate
      financeCommissionPercent
    }
  }
`;
